<template>

  <div class="login-bg">
    <div class="login-container">
      <div class="title">登录</div>
      <van-tabs v-model="active" title-active-color="#029FD1" color="#029FD1" style="font-size: 20px;" >
        <van-tab title="护士" name="N"  ></van-tab>
        <van-tab title="医生" name="D"   ></van-tab>
      </van-tabs>
      <el-form class="form" :model="ruleForm" :rules="rules" ref="ruleForm" size="medium" >
        <el-form-item  prop="Username">
          <el-input class="form-input" v-model="ruleForm.Username" placeholder="请输入用户名" >
            <el-image
            class="form-image"
            slot="prefix"
            :src="dengludanse"
            fit="contain"></el-image>
          </el-input>
        </el-form-item>
        <el-form-item  prop="Password">
          <el-input class="form-input" show-password v-model="ruleForm.Password" password placeholder="请输入密码">
            <el-image class="form-image" slot="prefix" :src="mima"  fit="contain"></el-image>
          </el-input>
        </el-form-item>
        <el-checkbox-group v-model="remember" >
          <el-checkbox label="true">记住密码</el-checkbox>
       </el-checkbox-group>
      </el-form>
      <el-button class="login" type="primary" size="medium" round v-loading.fullscreen.lock="fullscreenLoading" @click="submitForm('ruleForm')">登录</el-button>
      <!-- <div class="back-password"  @click="$router.push({path:'/password'})">找回密码</div> -->
      <el-button style="display:block ;margin:200px auto 0 auto" v-if="evn === 'development'" type="primary" size="medium " @click="checkEnv">切到到正式环境</el-button>
    </div>
  </div>

</template>

<script>
import { mapMutations } from 'vuex'
import mima from '@/assets/imgs/mima.png'
import {injectCallbackScan} from '@/tool/posRun'
import dengludanse from '@/assets/imgs/dengludanse.png'
import { Base64 } from 'js-base64'

  // let Base64 = require('js-base64').Base64;
export default {
  name: 'login',
  data () {
    return {
      active: 'N',
      fullscreenLoading:false,
      dengludanse,
      mima,
      evn:process.env.NODE_ENV,
      remember: [],
      ruleForm: {
          Username: '', //daihl 000321 admin Jxd598  护士
          Password: ''  //Hy8888 000321 xn Jxd598 医生
        },
        rules: {
          Username: [
            { required: true, message: '请输入账号', trigger: 'change' },
          ],
          Password: [
            { required: true, message: '请输入密码', trigger: 'change' },
          ],

        }
    }
  },
  created(){
    //  回填密码
    let name = localStorage.getItem('userName') || ''
    let password = localStorage.getItem('hyToken') || ''
    if(name && password){
      this.ruleForm.Username = name
      this.ruleForm.Password = Base64.decode(password.slice(11))
      this.remember = ['true']
    }

    this.active = localStorage.getItem('active') || 'N'


    // 注入手持机函数
    window.btnScanHandCallback=this.scanHandCallback
    injectCallbackScan()
  },
  methods: {
    ...mapMutations([
      'updatedUser',
      'setNursingSwitch'
    ]),

    // 保存密码
    savePassword(){
        console.log(process.env.NODE_ENV)
      if (this.remember[0] === 'true') {
        //  点击确定按钮，将值保存
        localStorage.setItem('userName',this.ruleForm.Username)
        // 调用函数将密码进行加密处理
        let random=this.randomWord(11)
        let encryption=random + Base64.encode( this.ruleForm.Password)
        localStorage.setItem('hyToken',encryption)
      } else {
        localStorage.removeItem('userName')
        localStorage.removeItem('hyToken')
      }
    },
     // 随机生成一串字母数字组合
    randomWord(num){
        let str = "",
          arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
        let pos;
        for(var i=0; i<num; i++){
            pos = Math.round(Math.random() * (arr.length-1));
            str += arr[pos];
        }
        return str;
    },
    // 切换环境
    checkEnv(){
      window.location.href="http://nurse.gshis.com/#/login?grpid=000081&comId=000081"
    },
    // 扫码函数
    scanHandCallback(str,minute=5){
        console.log('手持机扫码信息',str);
      if (this.$route.path === '/login') {
        this.$message({
           message: "未登录，请先登录",
         offset: 100,
        })
          return false
      }
      let arr=str.split(",")
      if(arr.length){
        let Id = arr[0]
        // let time = parseInt(arr[1])
        // let nowTime = new Date().getTime()
        // if((nowTime-time)>(minute*60*1000)){
        //   this.$notify.error({
        //     title: '错误',
        //     message: `二维码有效期为${minute}分钟，此二维码已过期！`,
        //     offset: 100,
        //     customClass:'notifyClass'
        //   });
        // }else{
        // this.$router.push({ name: 'nursingOneImplement', query: { Id }})
        // }
        // 相同的路由跳转相同的长者则不不跳转
        if (this.$route.name === 'nursingOneImplement' &&this.$store.state.scanCdoe === Id.toLocaleLowerCase()) return false
        this.$store.commit('setScanCode',Id.toLocaleLowerCase())
        this.$router.push({ name: 'nursingOneImplement', query: { Id:Id.toLocaleLowerCase() }})
      }else{
          this.$notify.error({
            title: '错误',
            message: `此二维码无效，请重新生成！`,
            offset: 100,
            customClass:'notifyClass'
          });
      }
    },
    // 提交登录表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.login()
        } else {
          return false;
        }
      });
    },

    //登录
    login(){
      this.fullscreenLoading = true;
      this.$axios.post('/Pad/login', {...this.ruleForm,ProductType:this.active})
      .then((res)=>{
        this.fullscreenLoading = false;
        this.savePassword()
        this.updatedUser(res.data.obj)
        this.$store.dispatch('getSystemData')
        // 判断首页需要展示的菜单
        localStorage.setItem('active' , this.active)
        this.$router.push({ name:'main' })
      }).catch(err=>{
        this.fullscreenLoading = false;
      })
    },
  },
  mounted () {
    this.setNursingSwitch(true)
  },
}
</script>
<style scoped>
.login-bg{
  position: fixed;
  width: 100%;
  height: 100%;
  background: #fff;
}
.login-container{
  position: fixed;
  top:140px;
  left: 50%;
  transform: translate(-50%,-0%);
}

 .login-container >>> .van-tabs__wrap .van-tab__text  {
  font-size: 20px !important;
}



.title{
  font-weight: bold;
  color: #029FD1;
  font-size: 30px;
  text-align: center;
  letter-spacing: 20px;
  text-indent: 20px;
  transform: translate(0px, -28px)
}
.form{
  width: 300px;
  margin: 36px auto;
}
.form-image{
  margin: 12px 9px;
  width: 17px;
  height: 17px;
}

.login{
  height: 40px;
  border-radius: 20px !important;
  width:100%;
  font-size: 16px;
  background: #029FD1;
}

.back-password {
  text-align: center;
  line-height: 36px;
  font-size:14px;
  color: #C0C4CC;
}

</style>



// WEBPACK FOOTER //
// src/components/login.vue